export interface TActivitySpace {
  ValidationResult?: Record<string, unknown>;
  Operation?: number;
  ActivitySpacesId: string;
  SpaceActivitiesId: string;
  ActivityId: string;
  TenantId?: string;
  Description: string;
}

export interface TSpaceActivities {
  ValidationResult?: Record<string, unknown>;
  Operation?: number;
  SpaceId: string;
  SpaceDescription: string;
  TenantId: string;
  ActivityId: string;
  ActivitiesSpaces: TActivitySpace[];
}

export type TBookingSettings = {
  TenantId: string;
  BookingEnabled: boolean;
  MaxNumberOfShedulesPerBooking: number;
  BookingDuration: number;
  TimeLimitForScheduling: number;
  TypeTimeLimitForScheduling: ETimeType;
  TimeLimitForCancellation: number;
  TypeTimeLimitForCancellation: ETimeType;
  TimeLimitForRescheduling: number;
  TypeTimeLimitForRescheduling: ETimeType;
  AddedOn?: string;
  AddedBy?: string;
  UpdatedOn?: string;
  UpdatedBy?: string;
  Operation?: any;
  ValidationResult?: Record<string, unknown>;
  IsValid?: boolean;
}

export enum ETimeType {
  MINUTE = 0,
  HOUR = 1,
  DAY = 2,
  WEEK = 3,
}

export enum ERepeatType {
  CUSTOM = 0,
  DAILY = 1,
  WEEKLY = 2,
  MONTHLY = 3,
  YEARLY = 4,
  MONDAY_TO_FRIDAY = 5,
  NONE = null
}

export type TUnavailableSchedules = {
  UnavailableScheduleId: string;
  UnavailableSpaceId: string;
  StartOn: string;
  EndOn: string;
  StartTime: string;
  EndTime: string;
  RepeatType: ERepeatType;
  Reason: string;
  UnavailableRepeated: Partial<TUnavailableRepeated>;
  Operation?: any;
  ValidationResult?: Record<string, unknown>;
  IsValid?: boolean;
}

export type TUnavailableSpace = {
  UnavailableSpaceId: string;
  SpaceId: string;
  SpaceDescription: string;
  UnavailableSchedules: Partial<TUnavailableSchedules>[];
  Operation?: any;
  ValidationResult?: Record<string, unknown>;
  IsValid?: boolean;
}

export type TUnavailableRepeated = {
  UnavailableScheduleId?: string;
  IsSunday: boolean;
  IsMonday: boolean;
  IsTuesday: boolean;
  IsWednesday: boolean;
  IsThursday: boolean;
  IsFriday: boolean;
  IsSaturday: boolean;
  Operation?: any;
  ValidationResult?: Record<string, unknown>;
  IsValid?: boolean;
}

export enum EActivityBase {
  All = 0,
  Local = 1,
  Actuar = 2
}

export type TValidateUnavailableSpace = {
  unavailableSpaceId: string;
  isValid: boolean;
}

export type TCancelBookingsByUnavailableSpace = {
  unavailableSpaceId: string;
  isCancelled: boolean;
}

export enum EBookingIds {
  BOOKING_CONDITIONS = 'booking-conditions',
  UNAVAILABILITY_CONFIGURATION = 'unavailability-configuration',
  SPACES_ACTIVITIES = 'spaces-activities',
  BOOKING_MESSAGES = 'booking-messages',
};

export const bookingPageFragments = [
  {
    title: 'SETTINGS.BOOKINGS.PERMISSIONS_BOOKING_CONDITIONS.TITLE',
    id: EBookingIds.BOOKING_CONDITIONS,
  },
  {
    title: 'SETTINGS.BOOKINGS.UNAVAILABILITY_CONFIGURATION.TITLE',
    id: EBookingIds.UNAVAILABILITY_CONFIGURATION,
  },
  {
    title: 'SETTINGS.BOOKINGS.SPACES_ACTIVITIES.TITLE',
    id: EBookingIds.SPACES_ACTIVITIES,
  },
  {
    title: 'SETTINGS.CRM.INSTANT_MESSAGING.BOOKING_CANCELLATION_MESSAGES',
    id: EBookingIds.BOOKING_MESSAGES,
  },
];